<template>
  <v-app-bar absolute height="85">
    <v-container class="px-0 text-right d-flex align-center">
      <div style="height: 50px; cursor: pointer" @click="goHome">
        <v-img :src="require(`@/assets/logo.png`)" width="50" />
      </div>
      <v-spacer />

      <v-btn v-if="authenticated" min-height="48" min-width="40" text to="/app">
        <v-icon size="20" v-text="'mdi-table'" />

        <span class="hidden-sm-and-down" v-text="$t('dashboard')" />
      </v-btn>

      <!-- <change-language-widget /> -->

      <!-- <v-btn v-if="!authenticated" min-height="48" min-width="40" text to="/register">
        <v-icon size="20" v-text="'mdi-account-multiple-plus'" />

        <span class="hidden-sm-and-down" v-text="$t('register')" />
      </v-btn> -->

      <v-btn v-if="!authenticated" min-height="48" min-width="40" text @click="login">
        <v-icon size="20" v-text="'mdi-fingerprint'" />

        <span class="hidden-sm-and-down" v-text="$t('login')" />
      </v-btn>

      <account-menu v-else />
    </v-container>
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PagesCoreAppBar',
  components: {
    AccountMenu: () => import('../app/widgets/AccountMenu.vue')
    // ChangeLanguageWidget: () => import('../app/widgets/ChangeLanguage.vue')
  },

  data: () => ({
    //
  }),
  computed: {
    ...mapGetters({
      authenticated: 'authenticated'
    })
  },
  methods: {
    goHome () {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      this.$router.push('/', () => {})
    },
    login () {
      this.$userService.login()
    }
  }
}
</script>

<style scoped></style>
